import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { ICours, defaultValue } from 'app/shared/model/cours.model';
const initialState: EntityState<ICours> = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ICours>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
  totalItems: 0,
};

const apiUrl = 'api/professeurs/cours';

// Actions

export const getProfesseurCours = createAsyncThunk('professeurs/fetch_cours', async (entity: any) => {
  let requestUrl;
  if (entity.startDate != null && entity.endDate != null) {
    requestUrl = `${apiUrl}?profId=${entity.profId}&startDate=${entity.startDate}&endDate=${entity.endDate}`;
  } else {
    requestUrl = `${apiUrl}?profId=${entity.profId}`;
  }

  return axios.get<ICours[]>(requestUrl);
});

export const updateCoursVolume = createAsyncThunk(
  'cours/update_volume',
  async (entity: { coursId: string; volume: string; profId: string }, thunkAPI) => {
    const result = await axios.patch<ICours>(`api/cours/${entity.coursId}/volume`, { volume: entity.volume });
    // Rafraîchir la liste des cours après mise à jour
    thunkAPI.dispatch(getProfesseurCours({ profId: entity.profId }));
    return result;
  },
  { serializeError: serializeAxiosError }
);

export type ClassetState = Readonly<typeof initialState>;

// slice

export const ClasseSlice = createSlice({
  name: 'cours',
  initialState: initialState as ClassetState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(updateCoursVolume.pending, state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.updating = true;
      })
      .addCase(updateCoursVolume.fulfilled, (state, action) => {
        state.updating = false;
        state.updateSuccess = true;
        state.entity = action.payload.data;
      })
      .addCase(updateCoursVolume.rejected, (state, action) => {
        state.updating = false;
        state.updateSuccess = false;
        state.errorMessage = action.error.message || 'Erreur lors de la mise à jour du volume';
      })
      .addMatcher(isPending(getProfesseurCours), state => {
        state.errorMessage = null;
        state.updateSuccess = false;
        state.loading = true;
      })
      .addMatcher(isFulfilled(getProfesseurCours), (state, action) => {
        state.loading = false;
        state.entities = action.payload.data;
        state.totalItems = parseInt(action.payload.headers['x-total-count'], 10);
      });
  },
});

export const { reset } = ClasseSlice.actions;

// Reducer
export default ClasseSlice.reducer;
